export const releaseNotesStyles = {
    container: { color: 'rgb(41, 45, 57)', padding: '0 3rem', margin: '2rem 0' },
    containerStyle: {
        marginRight: '0.5rem',
        border: '1px solid rgb(41, 45, 57, 0.4)',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        color: 'rgb(41, 45, 57)',
        backgroundColor: 'white',
        marginBottom: '10px',
    },
    tagsBar: {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-start',
        height: '80vh',
        position: 'sticky',
        overflow: 'auto',
        top: 0,
        left: 0,
    },
    rightSection: { display: 'flex', flexDirection: 'column', alignSelf: 'flex-start' },
    desc: {
        border: '1px solid rgb(41, 45, 57, 0.4)',
        borderRadius: 5,
        padding: 5,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    commitInfo: {
        backgroundColor: 'rgb(41, 45, 57, 0.1)',
        borderRadius: 5,
        padding: 2,
        border: '1px solid rgb(41, 45, 57)',
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90vh',
        width: '100%',
    },
}
